/* ── CPF ─────────────────────────────────────────────────────────── */
export function validateCPF(cpf) {
  const c = cpf.replace(/\D/g, '');
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(c[i]) * (10 - i);
  let r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(c[9])) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(c[i]) * (11 - i);
  r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  return r === parseInt(c[10]);
}

/* ── CNPJ ────────────────────────────────────────────────────────── */
export function validateCNPJ(cnpj) {
  const c = cnpj.replace(/\D/g, '');
  if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
  const calc = (c, n) => {
    let sum = 0, pos = n - 7;
    for (let i = n; i >= 1; i--) {
      sum += parseInt(c[n - i]) * pos--;
      if (pos < 2) pos = 9;
    }
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(c, 12) === parseInt(c[12]) && calc(c, 13) === parseInt(c[13]);
}

/* ── CNH ─────────────────────────────────────────────────────────── */
export function validateCNH(cnh) {
  const c = cnh.replace(/\D/g, '');
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  let sum = 0, second = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(c[i]) * (9 - i);
    second += parseInt(c[i]) * (1 + i);
  }
  const d1 = sum % 11;
  const d2 = second % 11;
  const digit1 = d1 >= 10 ? 0 : d1;
  const digit2 = d2 >= 10 ? 0 : d2;
  return digit1 === parseInt(c[9]) && digit2 === parseInt(c[10]);
}

/* ── Máscaras ────────────────────────────────────────────────────── */
export function maskCPF(v) {
  return v.replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    .slice(0, 14);
}

export function maskCNPJ(v) {
  return v.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
    .slice(0, 18);
}

export function maskCNH(v) {
  return v.replace(/\D/g, '').slice(0, 11);
}

export function maskPhone(v) {
  return v.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{1,4})$/, '$1-$2')
    .slice(0, 15);
}

export function maskCEP(v) {
  return v.replace(/\D/g, '')
    .replace(/(\d{5})(\d{1,3})$/, '$1-$2')
    .slice(0, 9);
}

/* ── Consulta CNPJ (BrasilAPI) ───────────────────────────────────── */
export async function fetchCNPJ(cnpj) {
  const c = cnpj.replace(/\D/g, '');
  if (c.length !== 14) throw new Error('CNPJ incompleto');
  const res = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${c}`);
  if (!res.ok) throw new Error('CNPJ não encontrado na Receita Federal');
  return res.json();
}

export function mapCNPJData(data) {
  const phone = (data.ddd_telefone_1 || '').replace(/\D/g, '');
  return {
    company_name: data.razao_social || '',
    trade_name:   data.nome_fantasia || '',
    email:        data.email ? data.email.toLowerCase() : '',
    phone:        phone ? maskPhone(phone) : '',
    zip_code:     maskCEP(data.cep || ''),
    address:      [data.logradouro, data.numero].filter(Boolean).join(', '),
    city:         data.municipio || '',
    state:        data.uf || '',
  };
}
